export default "__VITE_ASSET__BySxZR0y__"